import styled from "@emotion/styled";
import { PRIMARY_FONT, PRIMARY_BLUE } from "src/constants/colors";

export const StyledInput = styled.input`
  position: relative;
  z-index: 2;
  background-color: rgba(240, 241, 244, 1);
  border: 0;
  border-radius: 12px;
  box-sizing: border-box;
  color: ${PRIMARY_FONT};
  font-size: 16px;
  font-weight: 400;
  height: 54px;
  padding: 20px;
  width: 100%;

  &:focus {
    background-color: rgba(250, 250, 251, 1);
    box-shadow: 0px 0px 0px 7px rgba(20, 83, 245, 0.12);
    caret-color: ${PRIMARY_BLUE};
    outline: 3px solid ${PRIMARY_BLUE};
    transition: box-shadow 0.1s ease;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 22px;
  padding: 23px;
`;

export const ButtonWrapper = styled.div`
  max-width: 64px;
  margin-bottom: -6px;
`;
